
import { RenderModel } from './Render';

import { MakeEnvironment } from "./Environment";

import React from 'react';


export const BoxScene = () => { 
  
return (
    <>
      <RenderModel/>
      <MakeEnvironment/> 
    </>
  );
};
